import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { AppHolder } from '../AppHolder';
export var AdminPortal = /*#__PURE__*/function () {
  function AdminPortal() {
    _classCallCheck(this, AdminPortal);
  }
  _createClass(AdminPortal, null, [{
    key: "show",
    value: function show() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
      AppHolder.getInstance(name).showAdminPortal();
    }
  }, {
    key: "hide",
    value: function hide() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
      AppHolder.getInstance(name).hideAdminPortal();
    }
  }]);
  return AdminPortal;
}();